import { useTranslation } from 'react-i18next';
import type { FieldWidth } from '@platform/core/types';
import { fieldWidths } from './fieldTypeChoices';
import { HIDE } from './form/groupEdits';
import type { IFormFieldRowProps } from './IFormFieldRowProps';

/**
 * Рядок поля в групі редактора форми (прототип v4 feGroups → fields): підпис, тип (моноширинний), ширина («Авто · S», S · 1 одиниця,
 * M · 2 одиниці, L · увесь рядок), група поля або «Приховано», ↑ ↓ у межах групи; кожна зміна одразу зберігається.
 */
export function FormFieldRow({ field, label, width, auto, groupId, groups, first, last, disabled, onWidth, onMove, onStep }: IFormFieldRowProps) {
  const { t } = useTranslation();
  return (
    <div className="st-fef">
      <span className="st-fef__label" title={label}>{label}</span>
      <span className="st-fef__type">{t(`modDesign.types.${field.type}`, { defaultValue: field.type })}</span>
      <select className="st-select st-select--sm" value={width ?? ''} disabled={disabled} aria-label={t('modSettings.form.widthOf', { name: label })}
        onChange={(e) => onWidth((e.target.value || null) as FieldWidth | null)}>
        <option value="">{t('modSettings.widths.auto', { width: auto })}</option>
        {fieldWidths.map((w) => <option key={w} value={w}>{t(`modSettings.widths.${w}`)}</option>)}
      </select>
      <select className="st-select st-select--sm" value={groupId} disabled={disabled} aria-label={t('modSettings.form.groupOf', { name: label })} onChange={(e) => onMove(e.target.value)}>
        {groups.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
        <option value={HIDE}>{t('modSettings.form.hiddenGroup')}</option>
      </select>
      <span className="st-fef__moves">
        <button type="button" className="st-btn st-btn--icon" disabled={disabled || first} aria-label={t('modSettings.form.up')} onClick={() => onStep(-1)}>↑</button>
        <button type="button" className="st-btn st-btn--icon" disabled={disabled || last} aria-label={t('modSettings.form.down')} onClick={() => onStep(1)}>↓</button>
      </span>
    </div>
  );
}
